/**
 * サービスワーカーの登録。
 *
 * 登録 URL に `?v=<ビルドID>` を付けることで、デプロイのたびに
 * ブラウザが新しいサービスワーカーとして認識し、確実に更新が走る。
 * サービスワーカー側はこの値を読んでキャッシュ名に使う（public/service-worker.js）。
 */

// vite.config.ts の define で、ビルドごとに変わる文字列へ置換される。
declare const __BUILD_ID__: string;

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  // define による置換が効かない環境でも ReferenceError にならないようにする
  const buildId = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

  const register = (): void => {
    navigator.serviceWorker
      .register(`./service-worker.js?v=${buildId}`)
      .catch(() => undefined);
  };

  if (document.readyState === 'complete') {
    register();
  } else {
    window.addEventListener('load', register, { once: true });
  }
}
